import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './Question.module.less';
// import QuestionIem from './QuestionItem';
import { FEEDBACK_QUESTION as questionList } from '../../constants/userFeedback';

export default () => {
  const [activeQuestionType, setActiveQuestionType] = useState(questionList[0]);

  useEffect(() => {
    handleStatus(0)();
  }, []);
  const handleQuestionType = item => () => {
    setActiveQuestionType({
      ...item,
      child: item.child.map((el, index) => ({
        ...el,
        open: index === 0,
      })),
    });
  };
  const handleStatus = indexOpen => () => {
    setActiveQuestionType(ll => {
      return {
        ...ll,
        child: ll.child.map((item, index) => ({
          ...item,
          open: index === indexOpen ? !item.open : item.open,
        })),
      };
    });
  };

  return (
    <div className={styles.question}>
      <div className={styles.question_class}>
        {questionList.map(item => (
          <div
            key={item.name}
            className={classNames(styles.question_class_item, {
              [styles.active_text]: activeQuestionType.name === item.name,
            })}
            onClick={handleQuestionType(item)}
          >
            <div
              className={classNames(styles.question_class_disc, {
                [styles.active_bg]: activeQuestionType.name === item.name,
              })}
            />
            {item.text}
          </div>
        ))}
      </div>
      <div className={styles.question_detail}>
        {activeQuestionType.child.map((item, index) => (
          <div className={styles.question_detail_item} key={`${item.name}_${index}`}>
            <div
              className={classNames(styles.question_detail_item_text, {
                [styles.question_detail_item_text_wrap]: item.open,
              })}
              onClick={handleStatus(index)}
            >
              Q：{item.text}
              <i
                className={classNames(
                  'iconfont',
                  item.open ? 'icon-arrow_up_small' : 'icon-arrow_down_small',
                  styles.question_detail_icon,
                )}
              />
            </div>
            {item.open && (
              <div
                className={styles.question_detail_item_desc}
                dangerouslySetInnerHTML={{ __html: item.desc }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
